// extracted by mini-css-extract-plugin
export default {"base":"LabeledContent-module--base--65cd5","label":"LabeledContent-module--label--53423","slash":"LabeledContent-module--slash--e6d46"};